import * as React from 'react';
import { Button } from './button';
import { Plus, Trash2, Settings, Download } from 'lucide-react';

/**
 * Button Demo Component
 *
 * This component demonstrates all shadcn/ui Button variants and sizes.
 * Used for testing and verification that Tailwind CSS + shadcn setup works correctly.
 *
 * Usage: Import and render this component to test the Phase 1 setup.
 */
export function ButtonDemo() {
  return (
    <div className="p-8 space-y-8 bg-background text-foreground">
      <div>
        <h2 className="text-xl font-semibold mb-4">shadcn/ui Button Variants</h2>
        <div className="flex flex-wrap gap-4">
          <Button variant="default">Default</Button>
          <Button variant="secondary">Secondary</Button>
          <Button variant="destructive">Destructive</Button>
          <Button variant="outline">Outline</Button>
          <Button variant="ghost">Ghost</Button>
          <Button variant="link">Link</Button>
          <Button variant="success">Success</Button>
          <Button variant="warning">Warning</Button>
        </div>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-4">Button Sizes</h2>
        <div className="flex flex-wrap items-center gap-4">
          <Button size="sm">Small</Button>
          <Button size="default">Default</Button>
          <Button size="lg">Large</Button>
          <Button size="icon"><Plus /></Button>
        </div>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-4">Buttons with Icons</h2>
        <div className="flex flex-wrap gap-4">
          <Button><Plus className="mr-2" /> Add Holding</Button>
          <Button variant="destructive"><Trash2 className="mr-2" /> Delete</Button>
          <Button variant="outline"><Settings className="mr-2" /> Settings</Button>
          <Button variant="secondary"><Download className="mr-2" /> Export</Button>
        </div>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-4">Disabled State</h2>
        <div className="flex flex-wrap gap-4">
          <Button disabled>Disabled Default</Button>
          <Button variant="outline" disabled>Disabled Outline</Button>
          <Button variant="destructive" disabled>Disabled Destructive</Button>
        </div>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-4">Font Test (JetBrains Mono)</h2>
        <p className="font-mono text-lg">$123,456.78 | BTC: 0.00123456</p>
      </div>
    </div>
  );
}

export default ButtonDemo;
